import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as moment from 'moment';
import { defaultStore, initializeDefaultStore, loadState, combinedReducer } from '../common/redux-state'
import { storeUrl } from '../common/redux-state/actions/listing';
import { EventApp } from './components/app';
import { storeFilterOptions, upsertFilter, fetchEvents } from '../common/redux-state/actions/filters';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { IAppState } from '../common/classes/app';

var eventSearch = document.getElementById("event-entry-js");
var query = eventSearch.getAttribute("data-query");
//need to update query api endpoint
defaultStore.dispatch(storeUrl("/api/SearchResult/GetEvents?"));

defaultStore.dispatch(storeFilterOptions("/api/SearchResult/GetEventFilters") as any);
defaultStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));
defaultStore.dispatch(fetchEvents(moment()) as any);
var defaultSearchBox = query;
const savedState = loadState("eventState") as IAppState;
let updatedStore;
if (savedState) {
    // enable redux dev tools use
    let composeEnhancers = compose;
    if (process.env.NODE_ENV === 'development') {
        /* eslint-disable no-underscore-dangle */
        // @ts-ignore
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
            // @ts-ignore
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;
        /* eslint-enable */
    }
    //covert string back to date moment object 
    savedState.filtersState.currentMonth = moment(savedState.filtersState.currentMonth);
    savedState.filtersState.monthWithEvent = savedState.filtersState.monthWithEvent.map(item => moment(item));
    updatedStore = createStore(combinedReducer, savedState, composeEnhancers(applyMiddleware(thunk)));
    defaultSearchBox = savedState.filtersState.filters["QueryValue"];
}

initializeDefaultStore(updatedStore ? updatedStore : defaultStore);

var prevQuery = sessionStorage.getItem("prevQueryString")
if (prevQuery != query && updatedStore) {
    sessionStorage.setItem("prevQueryString", query);
    updatedStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));
    defaultSearchBox = query;
}

render(<Provider store={updatedStore ? updatedStore : defaultStore}>
    <EventApp searchBoxDefault={defaultSearchBox}/>
</Provider>, eventSearch);
